export default __webpack_public_path__ + "static/media/changeStatusIcon.06fc53da.svg";